import { render } from "./ModalProjectFilter.vue?vue&type=template&id=7ddb81d1&ts=true"
import script from "./ModalProjectFilter.vue?vue&type=script&lang=ts"
export * from "./ModalProjectFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__